/**
 * @fileoverview A foto da pessoa em Equipe e permissões ou, sem foto, as
 * iniciais em tom neutro (sem cor por pessoa): na lista, no painel e no filtro
 * do histórico. `small` é o tamanho das listas suspensas.
 */

import React from "react";

import { initials } from "../UsersTable";
import useTeamAccessStyles from "./styles";

const PersonAvatar = ({ name, image, small = false }) => {
  const classes = useTeamAccessStyles();
  const className = [classes.avatar, small ? classes.avatarSmall : ""].filter(Boolean).join(" ");
  return image ? (
    <img src={image} alt="" className={className} />
  ) : (
    <span className={className} aria-hidden="true">
      {initials(name)}
    </span>
  );
};

export default PersonAvatar;
